// extracted by mini-css-extract-plugin
var _1 = "staticPopover";
var _2 = "staticPopover__arrow";
var _3 = "staticPopover__arrow_bottom";
var _4 = "staticPopover__arrow_left";
var _5 = "staticPopover__arrow_right";
var _6 = "staticPopover__arrow_top";
var _7 = "staticPopover_bottom";
var _8 = "staticPopover_left";
var _9 = "staticPopover_right";
var _a = "staticPopover_top";
export { _1 as "staticPopover", _2 as "staticPopover__arrow", _3 as "staticPopover__arrow_bottom", _4 as "staticPopover__arrow_left", _5 as "staticPopover__arrow_right", _6 as "staticPopover__arrow_top", _7 as "staticPopover_bottom", _8 as "staticPopover_left", _9 as "staticPopover_right", _a as "staticPopover_top" }
